module.exports = __webpack_public_path__ + "static/media/Trending-up.6c941f11.svg";